import React from 'react';
import { CardHeaderRightTextSC } from './card-header-right-text.styled';

interface CardHeaderRightTextProps
  extends Omit<
    React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
    'ref'
  > {}

const CardHeaderRightText: React.FunctionComponent<CardHeaderRightTextProps> = (props) => {
  return <CardHeaderRightTextSC {...props} />;
};

export default CardHeaderRightText;
